export function generateJugDummy() {
  const id = generateUUID();
  const userId = `user-${Math.floor(Math.random() * 1000)}`;
  const addressId = `address-${Math.floor(Math.random() * 1000)}`;
  const familyId = `family-${Math.floor(Math.random() * 1000)}`;
  const capacity = Math.random() * 10 + 1;
  const material = getRandomMaterial();
  const status = getRandomStatus();
  const type = getRandomType();
  const purchaseDate = getRandomDate();
  const expirationDate = getRandomDate();
  const createdAt = getRandomDateTime();
  const updatedAt = createdAt;

  return {
    id,
    user_id: userId,
    address_id: addressId,
    family_id: familyId,
    capacity: capacity.toFixed(2),
    material,
    status,
    type,
    purchase_date: purchaseDate,
    expiration_date: expirationDate,
    created_at: createdAt,
    updated_at: updatedAt,
  };
}

export function generateUUID() {
  return `${Math.floor(Math.random() * 1000000000).toString(16)}`;
}

function getRandomMaterial() {
  const materials = ["Glass", "Plastic", "Metal", "Ceramic"];
  return materials[Math.floor(Math.random() * materials.length)];
}

function getRandomStatus() {
  const statuses = ["free", "assigned", "in_use"];
  return statuses[Math.floor(Math.random() * statuses.length)];
}

function getRandomType() {
  const types = ["purchase", "rental"];
  return types[Math.floor(Math.random() * types.length)];
}

function getRandomDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = Math.floor(Math.random() * 12) + 1;
  const day = Math.floor(Math.random() * 28) + 1;
  return `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
}

function getRandomDateTime() {
  const date = new Date();
  const year = date.getFullYear();
  const month = Math.floor(Math.random() * 12) + 1;
  const day = Math.floor(Math.random() * 28) + 1;
  const hour = Math.floor(Math.random() * 24);
  const minute = Math.floor(Math.random() * 60);
  const second = Math.floor(Math.random() * 60);
  return `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")} ${hour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
}

export function formatPrice(price) {
  if (typeof price === "string") {
    price = parseFloat(price.replace(/[^\d\.]/g, ""));
  }
  if (isNaN(price)) return "0";
  return price.toLocaleString("es-ES", { useGrouping: true, separator: "." });
}

export const processGeoJSON = (geoJSON) => {
  try {
    const features = geoJSON.features;
    if (!features || features.length === 0) {
      throw new Error("No se encontraron características en el GeoJSON");
    }

    const polygonFeature = features.find(
      (feature) => feature.geometry.type === "Polygon"
    );
    if (!polygonFeature) {
      throw new Error("No se encontró un polígono en el GeoJSON");
    }

    const coordinates = polygonFeature.geometry.coordinates[0];
    const polygonPath = coordinates.map((coord) => ({
      lat: coord[1],
      lng: coord[0],
    }));

    // Calcular el centro del polígono
    const sumLat = polygonPath.reduce((sum, coord) => sum + coord.lat, 0);
    const sumLng = polygonPath.reduce((sum, coord) => sum + coord.lng, 0);
    const center = {
      lat: sumLat / polygonPath.length,
      lng: sumLng / polygonPath.length,
    };

    return {
      polygonPath,
      center,
    };
  } catch (error) {
    console.error("Error al procesar el GeoJSON:", error);
    return null;
  }
};

export function isValidEmail(email) {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(email);
}

export function handlePhoneChange(event, setPhone) {
  let input = event.target.value;

  // Si el input ya tiene "+57", lo eliminamos para procesarlo
  if (input.startsWith("+57")) {
    input = input.slice(3).trim();
  }

  // Limpiamos el input dejando solo los números
  const numbers = input.replace(/\D/g, "");

  // Si el usuario intenta borrar y queda vacío, permitimos que el campo se limpie
  if (numbers === "") {
    setPhone("+57");
    return;
  }

  // Verificamos si el número comienza con 3, solo si hay contenido
  if (!numbers.startsWith("3") && numbers.length > 0) {
    return; // Salimos sin actualizar el estado si no empieza con "3"
  }

  // Formateamos el número dejando "+57" fijo y agregando los espacios
  let formatted = "+57";
  if (numbers.length > 0) {
    formatted += " " + numbers.slice(0, 3); // Los primeros 3 dígitos
  }
  if (numbers.length >= 4) {
    formatted += " " + numbers.slice(3, 6); // Los siguientes 3 dígitos
  }
  if (numbers.length >= 7) {
    formatted += " " + numbers.slice(6, 10); // Los últimos 4 dígitos
  }

  setPhone(formatted);
}

export function handleEmailChange(event, setEmail) {
  const newEmail = event.target.value;
  setEmail(newEmail);

  // You can add more complex validation if needed
  if (isValidEmail(newEmail)) {
    // Email is valid, you can update other states or perform actions
  } else {
    // Email is invalid, you can set an error state or show a message
  }
}

export const capitalizeWords = (str) => {
  return str.replace(
    /\b\w{3,}/g,
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
};

export const handleNameChange = (event, setName) => {
  const input = event.target.value;
  const sanitizedInput = input.replace(/[^a-zA-Z\s]/g, "");
  const capitalizedInput = capitalizeWords(sanitizedInput);
  setName(capitalizedInput);
};

export function cleanStringNumber(string) {
  if (!string) return "";
  return string.replace(/\D+/g, "").replace(/\s+/g, "");
}

export const generateEpochUniqueId = (() => {
  let lastTimestamp = 0;
  let sequence = 0;

  return () => {
    let timestamp = new Date();

    if (timestamp === lastTimestamp) {
      sequence++;
    } else {
      sequence = 0;
      lastTimestamp = timestamp;
    }

    // Combina el timestamp con la secuencia
    const combined = timestamp * 1000 + sequence;

    // Convierte a base 36, toma los últimos 8 caracteres, rellena con ceros y convierte a mayúsculas
    return combined.toString(36).slice(-8).padStart(8, "0").toUpperCase();
  };
})();

export const sendLeadToWebhook = async (webhookUrl, leadData) => {
  if (!webhookUrl) {
    console.error("URL de webhook no proporcionada");
    return;
  }
  
  try {
    const response = await fetch(webhookUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(leadData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error al enviar el lead al webhook:", error);
  }
};

export const focusAddressDetails = (ref) => {
  setTimeout(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    ref.current?.focus();
  }, 400);
};

export const getOperationalStateColor = (state) => {
  if (state === "recently_ordered" || state === "on_production")
    return "bg-blue-500 text-white";
  if (state === "to_be_returned" || state === "overdue_for_return")
    return "bg-red-500 text-white";
  if (state === "in_inventory" || state === "refill_base")
    return "bg-green-500 text-white";
  if (
    [
      "ready_for_production",
      "in_washing",
      "in_filling",
      "ready_for_delivery",
    ].includes(state)
  )
    return "bg-purple-500 text-white";
  return "bg-gray-500 text-white";
};

// Función para formatear estados en texto más legible
export const formatState = (state) => {
  if (!state) return "";
  return state
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Obtener color de badge según estado físico
export const getPhysicalStateColor = (state) => {
  const colors = {
    new: "bg-blue-500 text-white",
    excellent: "bg-green-500 text-white",
    good: "bg-green-300 text-white",
    regular: "bg-yellow-500 text-white",
    deteriorated: "bg-orange-500 text-white",
    discarded: "bg-red-500 text-white",
  };
  return colors[state] || "bg-gray-500 text-white";
};

// Formato de fecha para mostrar
export const formatDate2 = (dateString) => {
  if (!dateString) return "No asignada";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-CO", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Formato de fecha y hora para mostrar
export const formatDateTime = (dateString) => {
  if (!dateString) return "No registrada";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-CO", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Obtener nombre completo del cliente
export const getCustomerName = (userData) => {
  if (!userData) return "Cliente no asignado";
  return `${userData.first_name} ${userData.last_name}`;
};

// Calcular días desde la entrega
export const getDaysSinceDelivery = (deliveryDate) => {
  if (!deliveryDate) return "N/A";
  const delivered = new Date(deliveryDate);
  const today = new Date();
  const diffTime = today - delivered;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// Opciones de estado operacional
export const statusOptions = [
  { value: "recently_ordered", label: "Recién pedido", icon: "📋" },
  { value: "ready_for_production", label: "Cola de producción", icon: "⏳" },
  { value: "in_washing", label: "En lavado", icon: "🧼" },
  { value: "in_filling", label: "En llenado", icon: "🚰" },
  { value: "ready_for_delivery", label: "Listo para entrega", icon: "📦" },
  { value: "in_transit", label: "En tránsito", icon: "🚚" },
  { value: "delivered", label: "Entregado", icon: "✅" },
  { value: "not_delivered", label: "No entregado", icon: "❌" },
  { value: "rejected", label: "Rechazado", icon: "🚫" },
  { value: "to_be_refilled", label: "Para recambio", icon: "🔄" },
  { value: "to_be_returned", label: "Para devolución", icon: "↩️" },
  { value: "returning", label: "Retornando", icon: "⬅️" },
  { value: "expired", label: "Vencido", icon: "⏱️" },
  { value: "overdue_for_return", label: "Devolución vencida", icon: "⚠️" },
];

// Opciones de estado de pago
export const paymentStatusOptions = [
  { value: "pending", label: "Pendiente", icon: "⏳" },
  { value: "processing", label: "Procesando", icon: "⚙️" },
  { value: "paid", label: "Pagado", icon: "💰" },
  { value: "partially_paid", label: "Pago parcial", icon: "💸" },
  { value: "failed", label: "Fallido", icon: "❌" },
  { value: "refunded", label: "Reembolsado", icon: "↩️" },
  { value: "cancelled", label: "Cancelado", icon: "🚫" },
];

// Estados de pago que no se pueden cambiar
export const nonEditablePaymentStates = ["paid", "cancelled", "refunded"];

// Orden de los estados operacionales para validación
export const operationalStateOrder = [
  "recently_ordered",
  "ready_for_production",
  "in_washing",
  "in_filling",
  "ready_for_delivery",
  "in_transit",
  "delivered",
  "not_delivered",
  "rejected",
  "to_be_refilled",
  "to_be_returned",
  "returning",
  "expired",
  "overdue_for_return",
];

export const documentTypes = [
  { value: "national_id", label: "Cédula de ciudadanía" },
  { value: "passport", label: "Pasaporte" },
  { value: "residence_card", label: "Cédula de extranjería" },
  { value: "refugee_id", label: "ID de refugiado" },
  { value: "nit", label: "NIT" },
  { value: "other", label: "Otro" },
];

// Lista de países
export const countries = [
  "argentina",
  "bolivia",
  "brazil",
  "chile",
  "colombia",
  "costa rica",
  "cuba",
  "ecuador",
  "el salvador",
  "guatemala",
  "haiti",
  "honduras",
  "mexico",
  "nicaragua",
  "panama",
  "paraguay",
  "peru",
  "dominican republic",
  "uruguay",
  "venezuela",
  "spain",
  "france",
  "germany",
  "italy",
  "portugal",
  "united kingdom",
];

// Validar número de teléfono (sin prefijo)
export const validatePhone = (phone) => {
  // Eliminar cualquier caracter no numérico
  const numericValue = phone.replace(/\D/g, "");

  return {
    isValid: numericValue.length >= 7 && numericValue.length <= 10,
    cleanValue: numericValue,
    errorMessage:
      numericValue.length < 7
        ? "El número debe tener al menos 7 dígitos"
        : numericValue.length > 10
        ? "El número no debe exceder 10 dígitos"
        : "",
  };
};

// Validar número de documento
export const validateDocument = (document, type) => {
  // Eliminar cualquier caracter no numérico
  const numericValue = document.replace(/\D/g, "");

  // Ajustar longitud según tipo de documento
  let maxLength = 10; // Por defecto

  if (type === "national_id") maxLength = 10; // Cédula colombiana
  else if (type === "passport") maxLength = 15; // Pasaporte
  else if (type === "nit") maxLength = 12; // NIT

  return {
    isValid: numericValue.length > 0 && numericValue.length <= maxLength,
    cleanValue: numericValue,
    errorMessage:
      numericValue.length > maxLength
        ? `El documento no debe exceder ${maxLength} dígitos`
        : "",
  };
};

export const formatDate = (date, isCompact = false) => {
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    if (isCompact) {
      return {
        dayName: capitalize(
          date.toLocaleDateString("es-CO", { weekday: "long" })
        ),
        dayNumber: date.getDate(),
        month: capitalize(date.toLocaleDateString("es-CO", { month: "long" })),
      };
    }

    const weekday = capitalize(
      date.toLocaleDateString("es-CO", { weekday: "long" })
    );
    const day = date.getDate();
    const month = capitalize(
      date.toLocaleDateString("es-CO", { month: "long" })
    );

    return `${weekday}, ${day} de ${month}`;
  };

  // Agregar estas funciones al final de src/scripts/generalScript.js
/**
 * Obtiene información completa de un slot de tiempo
 * @param {string} slot - 'morning' o 'afternoon'
 * @returns {object} Objeto con toda la información del slot
 */
export const getTimeSlotInfo = (slot) => {
  const slots = {
    morning: {
      code: 'morning',
      label: 'Por la mañana',
      shortLabel: 'Mañana',
      time: '8:00 am - 12:00 pm',
      start: 8,
      end: 12,
      icon: '☀️'
    },
    afternoon: {
      code: 'afternoon', 
      label: 'Por la tarde',
      shortLabel: 'Tarde',
      time: '2:00 pm - 6:00 pm',
      start: 14,
      end: 18,
      icon: '🌤️'
    }
  };
  
  return slots[slot] || null;
};

/**
 * Formatea un slot de tiempo con información rica
 * @param {string} slot - 'morning' o 'afternoon'
 * @param {object} options - Opciones de formato
 * @returns {string} Horario formateado
 */
export const formatTimeSlotRich = (slot, options = {}) => {
  const { 
    showIcon = false, 
    showLabel = true, 
    showTime = true,
    separator = ' - '
  } = options;
  
  const slotInfo = getTimeSlotInfo(slot);
  if (!slotInfo) return "";
  
  let result = "";
  
  if (showIcon) result += `${slotInfo.icon} `;
  if (showLabel) result += slotInfo.shortLabel;
  if (showTime) {
    if (showLabel) result += ` ${separator}`;
    result += slotInfo.time;
  }
  
  return result;
};

export const formatTimeSlot = (slot, isCompact = false) => {
  if (!slot) return "";
  
  if (isCompact) {
    return slot === "morning" ? "Mañana" : "Tarde";
  }
  
  return slot === "morning"
    ? "Mañana (8:00 am - 12:00 pm)"
    : "Tarde (2:00 pm - 6:00 pm)";
};